import { computed, ComputedRef, Ref, unref } from 'vue'
import { sdk } from '@/authentication/coodeSdkConfig'

export const STALE_TIME = 300000 // 5 minutes

export const whenAuthenticated = computed(() => sdk?.auth?.isAuthenticated())

export const whenAuthenticatedAnd = (condition: Ref<boolean> | boolean): ComputedRef<boolean> => {
    return computed(() => sdk?.auth?.isAuthenticated() && unref(condition))
}
